module.exports = __webpack_public_path__ + "static/media/alice2.b94af6a0.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/alice2.JPG
// module id = 53
// module chunks = 0